const EMAIL_RE = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export function isValidEmail(value) {
  if (!value) return false;
  if (value.length > 254) return false;
  return EMAIL_RE.test(value.trim());
}

export function isValidOtp(value) {
  return /^\d{6}$/.test(value);
}

export function normalizeOtpInput(raw) {
  return String(raw).replace(/\D/g, '').slice(0, 6);
}
